import dayjs from "dayjs";
import { useLanguage } from "assets/languages";
import { GuidelineRuleDto } from "api/repositories/guidelineRules/guidelineRules.types";
import GUIDELINE_RULES from "constants/guidelineRules";

const makeProductName = (productName:string, preferredVideoTypeGuidelineRules?:GuidelineRuleDto[], campaign?:any) => {
  const language = useLanguage();

  if (!preferredVideoTypeGuidelineRules && !campaign?.isSingleDayPosting)
    return productName;

  let preferredVideoTypeValueTexts:string[] = [];
  if (preferredVideoTypeGuidelineRules) {
    preferredVideoTypeValueTexts = preferredVideoTypeGuidelineRules
      .filter((rule) => rule.groupName === GUIDELINE_RULES.GROUP_NAMES.PREFERRED_VIDEO_TYPE)
      .map((rule) => GUIDELINE_RULES.GetOptionTranslationMap(rule.groupName, `${rule.value}`));
  }
  
  let singleDayPostingTag = '';
  if (campaign?.isSingleDayPosting && campaign?.postingEndsAt) {
    singleDayPostingTag = language.helper.ui.single_day_posting_product_tag(
      dayjs(campaign.postingEndsAt).subtract(2, 'day').format('M/D'),
    );
  }

  let output = '';
  if (preferredVideoTypeValueTexts.length > 0) {
    output = `[${preferredVideoTypeValueTexts.join('|')}]`;
  }
  if (singleDayPostingTag.length > 0) {
    output += `${singleDayPostingTag}`;
  }
  if (output.length > 0) {
    output += ` `;
  }
  output += productName;
  return output;
}

const HELPER_UI = {
  makeProductName,
};

export default HELPER_UI;
  